import {merge} from 'lodash';
import Assessment from '../assessment';
import AssessmentResult from '../../../values/AssessmentResult';
import {MAIN_CONTENT_POINTS, SUBHEADINGS_KEYWORD_ID} from '@axyseo/const/analysis';

/**
 * Represents the assessment that checks if the keyword is present in one of the subheadings.
 */
export default class SubHeadingsKeywordAssessment extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {object} config The configuration to use.
   *
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: SUBHEADINGS_KEYWORD_ID,
      ctaType: 'fix',
      docUrl:
        'https://docs.avada.io/seo-suite-help-center/seo-on-page-audit/checklist#missing-main-keyword-in-subheading',
      priority: 'medium',
      fixPosition: 'subheading',
      title: 'Keyword in Subheading',
      content: {
        good: 'Keywords are included in subheadings.',
        bad:
          'Keyword not found in any subheadings. Include it in at least one subheading (H2, H3, etc.).',
        improve: ''
      }
    };

    this.identifier = SUBHEADINGS_KEYWORD_ID;
    this._config = merge(defaultConfig, config);
  }

  /**
   * Runs the h1 research and based on this returns an assessment result with a score.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   * @param {Researcher}  researcher  The researcher used for calling the research.
   * @returns {AssessmentResult} The assessment result.
   */
  getResult({paper, researcher}) {

    this._subHeadings = researcher.getResearch('matchKeywordInSubheadings');

    const assessmentResult = new AssessmentResult({config: this._config});

    const calculatedResult = this.calculateResult(paper);

    assessmentResult.setScore(calculatedResult.score);
    assessmentResult.setStatus(calculatedResult.status);

    return assessmentResult;
  }

  /**
   *
   * @returns {{score: number, status: string}}
   */
  calculateResult() {
    let status = 'bad';
    if (this._subHeadings.matches > 0) {
      status = 'good';
    }


    return {
      score:  this.getScore(MAIN_CONTENT_POINTS, status) || 0,
      status
    };
  }

  /**
   * Checks whether the paper has a text.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   *
   * @returns {boolean} True when there is text.
   */
  isApplicable(paper) {
    return true;
  }
}
